import type { BusinessTypes } from './business-type-v2'
import {
  ARTIST_MANAGEMENT,
  LABEL,
  MUSIC_CREATOR,
  MUSIC_SUPERVISION,
  OTHER,
  PODCAST_CONTENT_CREATION,
  POST_PRODUCTION,
  PRODUCTION_MUSIC_LIBRARY,
  PROMOTIONS,
  PUBLISHER,
  RADIO_STATION,
  SYNC_AGENCY_REP,
} from './business-type-v2'
export const A_R = 'a_r'
export const AD_AGENCY_IN_HOUSE = 'ad_agency_in_house'
export const ARTIST = 'artist'
export const BAND = 'band'
export const CATALOGUE_MANAGER = 'catalogue_manager'
export const COMMERCIAL_DSP_PLAYLISTING = 'commercial_dsp_playlisting'
export const COMPOSER = 'composer'
export const CONTENT_CREATOR = 'content_creator'
export const COORDINATOR = 'coordinator'
export const DJ = 'dj'
export const DSP_PLAYLISTING = 'dsp_playlisting'
export const DIGITAL_MARKETING = 'digital_marketing'
export const ENGINEER = 'engineer'
export const FREELANCE_SUPERVISOR = 'freelance_supervisor'
export const MANAGER = 'manager'
export const MARKETING_PR = 'marketing_pr'
export const MUSIC_DIRECTOR = 'music_director'
export const MUSIC_EDITOR = 'music_editor'
export const MUSIC_SUPERVISION_COMPANY_IN_HOUSE =
  'music_supervision_company_in_house'
export const MUSIC_SUPERVISOR_RESEARCHER = 'music_supervisor_researcher'
export const NETWORK_IN_HOUSE = 'network_in_house'
export const PR = 'pr'
export const PLAYLISTING = 'playlisting'
export const PODCASTER = 'podcaster'
export const PRODUCER = 'producer'
export const PROGRAM_MANAGER = 'program_manager'
export const RADIO = 'radio'
export const SONGWRITER = 'songwriter'
export const STUDIO_IN_HOUSE = 'studio_in_house'
export const SYNC_CREATIVE = 'sync_creative'
export const TALENT_AGENCY = 'talent_agency'
export const TRAILER_IN_HOUSE = 'trailer_in_house'
export const VIDEO_EDITOR = 'video_editor'
export type JobsType =
  | typeof A_R
  | typeof AD_AGENCY_IN_HOUSE
  | typeof ARTIST
  | typeof BAND
  | typeof CATALOGUE_MANAGER
  | typeof COMMERCIAL_DSP_PLAYLISTING
  | typeof COMPOSER
  | typeof CONTENT_CREATOR
  | typeof COORDINATOR
  | typeof DJ
  | typeof DSP_PLAYLISTING
  | typeof DIGITAL_MARKETING
  | typeof ENGINEER
  | typeof FREELANCE_SUPERVISOR
  | typeof MANAGER
  | typeof MARKETING_PR
  | typeof MUSIC_DIRECTOR
  | typeof MUSIC_EDITOR
  | typeof MUSIC_SUPERVISION_COMPANY_IN_HOUSE
  | typeof MUSIC_SUPERVISOR_RESEARCHER
  | typeof NETWORK_IN_HOUSE
  | typeof PR
  | typeof PLAYLISTING
  | typeof PODCASTER
  | typeof PRODUCER
  | typeof PROGRAM_MANAGER
  | typeof RADIO
  | typeof SONGWRITER
  | typeof STUDIO_IN_HOUSE
  | typeof SYNC_CREATIVE
  | typeof TALENT_AGENCY
  | typeof TRAILER_IN_HOUSE
  | typeof VIDEO_EDITOR
  | null
export const JOBS_LABEL_MAP: Record<Exclude<JobsType, null>, string> = {
  [A_R]: 'A&R',
  [AD_AGENCY_IN_HOUSE]: 'Ad Agency (in-house)',
  [ARTIST]: 'Artist',
  [BAND]: 'Band',
  [CATALOGUE_MANAGER]: 'Catalogue Manager',
  [COMMERCIAL_DSP_PLAYLISTING]: 'Commercial DSP Playlisting',
  [COMPOSER]: 'Composer',
  [CONTENT_CREATOR]: 'Content Creator',
  [COORDINATOR]: 'Coordinator',
  [DJ]: 'DJ',
  [DSP_PLAYLISTING]: 'DSP Playlisting',
  [DIGITAL_MARKETING]: 'Digital Marketing',
  [ENGINEER]: 'Engineer',
  [FREELANCE_SUPERVISOR]: 'Freelance Supervisor',
  [MANAGER]: 'Manager',
  [MARKETING_PR]: 'Marketing/PR',
  [MUSIC_DIRECTOR]: 'Music Director',
  [MUSIC_EDITOR]: 'Music Editor',
  [MUSIC_SUPERVISION_COMPANY_IN_HOUSE]: 'Music Supervision Company (in-house)',
  [MUSIC_SUPERVISOR_RESEARCHER]: 'Music Supervisor Researcher',
  [NETWORK_IN_HOUSE]: 'Network (in-house)',
  [PR]: 'PR',
  [PLAYLISTING]: 'Playlisting',
  [PODCASTER]: 'Podcaster',
  [PRODUCER]: 'Producer',
  [PROGRAM_MANAGER]: 'Program Manager',
  [RADIO]: 'Radio',
  [SONGWRITER]: 'Songwriter',
  [STUDIO_IN_HOUSE]: 'Studio (in-house)',
  [SYNC_CREATIVE]: 'Sync Creative',
  [TALENT_AGENCY]: 'Talent Agency',
  [TRAILER_IN_HOUSE]: 'Trailer (in-house)',
  [VIDEO_EDITOR]: 'Video Editor',
}
export const JOBS_MAP: Record<Exclude<BusinessTypes, null>, JobsType[]> = {
  [MUSIC_SUPERVISION]: [
    MUSIC_SUPERVISION_COMPANY_IN_HOUSE,
    FREELANCE_SUPERVISOR,
    TRAILER_IN_HOUSE,
    AD_AGENCY_IN_HOUSE,
    STUDIO_IN_HOUSE,
    NETWORK_IN_HOUSE,
    PLAYLISTING,
  ],
  [POST_PRODUCTION]: [MUSIC_EDITOR, VIDEO_EDITOR, PRODUCER],
  [LABEL]: [
    SYNC_CREATIVE,
    A_R,
    MARKETING_PR,
    COMMERCIAL_DSP_PLAYLISTING,
    CATALOGUE_MANAGER,
  ],
  [PUBLISHER]: [SYNC_CREATIVE, A_R, CATALOGUE_MANAGER],
  [SYNC_AGENCY_REP]: [SYNC_CREATIVE, CATALOGUE_MANAGER, COORDINATOR],
  [PRODUCTION_MUSIC_LIBRARY]: [
    MUSIC_SUPERVISOR_RESEARCHER,
    CATALOGUE_MANAGER,
    A_R,
  ],
  [MUSIC_CREATOR]: [ARTIST, BAND, COMPOSER, PRODUCER, ENGINEER, SONGWRITER],
  [ARTIST_MANAGEMENT]: [MANAGER, TALENT_AGENCY],
  [PROMOTIONS]: [RADIO, PR, DIGITAL_MARKETING, DSP_PLAYLISTING],
  [RADIO_STATION]: [PROGRAM_MANAGER, MUSIC_DIRECTOR, DJ],
  [PODCAST_CONTENT_CREATION]: [PODCASTER, CONTENT_CREATOR],
  [OTHER]: [],
}
